import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

function normalizeDigits(value) {
  if (!value) {
    return '';
  }

  return String(value).replace(/\D/g, '');
}

function buildInternationalPhoneNumber(countryCode, phoneValue) {
  const phoneDigits = normalizeDigits(phoneValue);
  const ddiDigits = normalizeDigits(countryCode);

  if (!phoneDigits || !ddiDigits) {
    return null;
  }

  return `+${ddiDigits}${phoneDigits}`;
}

function isValidInternationalPhoneNumber(countryCode, phoneValue) {
  if (!phoneValue) {
    return true;
  }

  const internationalNumber = buildInternationalPhoneNumber(countryCode, phoneValue);

  if (!internationalNumber) {
    return false;
  }

  const parsed = parsePhoneNumberFromString(internationalNumber);

  return parsed ? parsed.isValid() : false;
}

export { buildInternationalPhoneNumber, isValidInternationalPhoneNumber, normalizeDigits };
